export enum SurveyJobStatusEnum {
  Open = 1,
  Closed,
}
